/* eslint-disable @typescript-eslint/no-empty-function */
/*
 * @Author: chenchaoqiang@leedarson.com
 * @Date: 2022-08-03 09:40:01
 * Copyright 2022 Leedarson, All Rights Reserved.
 */

export default {
  EMPTY_FUNCTION: () => {},
  EMPTY_OBJECT: Object.freeze({}),
  EMPTY_ARRAY: Object.freeze([]),
};
